/*
function getCookie (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}
*/

export default function isLoggued() {
    const state = store.getState();
    const { user } = state;

    //console.log('ISLOGUED');
    //console.log(user);

    //const session = getCookie('session');
    //console.log('SESSION');
    //console.log(session);

    if (user && user.uuid) {
        return true;
    }

    return false;
}
